export default function PaymentSuccessPage() {
  return (
    <div className="text-center p-8">
      <h1 className="text-2xl font-bold text-green-600 mb-4">Payment Successful!</h1>
      <p>Thank you for your payment. You can now return to your dashboard.</p>
      <a href="/owner/invoices" className="mt-4 inline-block text-blue-700 underline">Go to My Invoices</a>
    </div>
  );
}
